import { PaletteOptions } from "@mui/material";

import { darkPalette as energieDarkPalette, lightPalette as energieLightPalette } from "./energie";
import { darkPalette as heathcareDarkPalette, lightPalette as healthcareLightPalette } from "./health-care";
import { darkPalette as foodDarkPalette, lightPalette as foodLightPalette } from "./food-wld";
import { darkPalette as autoDarkPalette, lightPalette as autoLightPalette } from "./auto-wld";
import {
  darkPalette as propertyDarkPalette,
  lightPalette as propertyLightPalette,
} from "./property";
import { getEnvironmentMode } from "@/utils/env";

export const getPalette = () => {
  const mode = getEnvironmentMode();

  const palettes = {
    energie: { lightPalette: energieLightPalette, darkPalette: energieDarkPalette },
    "food-wld": { lightPalette: foodLightPalette, darkPalette: foodDarkPalette },
    property: { lightPalette: propertyLightPalette, darkPalette: propertyDarkPalette },
    "hcare-wld": { lightPalette: healthcareLightPalette, darkPalette: heathcareDarkPalette },
    "auto-wld" :{ lightPalette: autoLightPalette, darkPalette: autoDarkPalette }, 
  };

  return palettes[mode];
};

const { lightPalette: selectedLightPalette, darkPalette: selectedDarkPalette } = getPalette();

export const lightPalette: PaletteOptions = selectedLightPalette;
export const darkPalette: PaletteOptions = selectedDarkPalette;

export type PaletteType = "light" | "dark";
export type ThemeMode = "system" | "light" | "dark";
export const THEME_VALUES = { SYSTEM: "system", LIGHT: "light", DARK: "dark" };
